var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttatch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0324 4.29745C14.0754 3.34551 12.5228 3.34551 11.5658 4.29745L4.71194 11.1151C3.26269 12.5567 3.26269 14.8929 4.71194 16.3345C6.16266 17.7776 8.51583 17.7776 9.96655 16.3345L16.5224 9.81329C16.7182 9.61855 17.0347 9.61939 17.2295 9.81516C17.4242 10.0109 17.4234 10.3275 17.2276 10.5223L10.6718 17.0435C8.83098 18.8746 5.84752 18.8746 4.00671 17.0435C2.16443 15.211 2.16443 12.2387 4.00671 10.4061L10.8605 3.58848C12.2076 2.2485 14.3906 2.2485 15.7377 3.58848C17.0862 4.92991 17.0862 7.1059 15.7377 8.44733L8.88383 15.265C8.03048 16.1138 6.64801 16.1138 5.79466 15.265C4.93984 14.4147 4.93984 13.035 5.79466 12.1847L11.1585 6.84909C11.3543 6.65435 11.6709 6.65519 11.8656 6.85097C12.0604 7.04674 12.0595 7.36333 11.8638 7.55807L6.4999 12.8936C6.0381 13.353 6.0381 14.0967 6.4999 14.556C6.96316 15.0168 7.71534 15.0168 8.1786 14.556L15.0324 7.73835C15.9879 6.78787 15.9879 5.24793 15.0324 4.29745Z",
    fill: "#5B5C5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttatch);
export default __webpack_public_path__ + "static/media/Attatch.7e0c1c06339b8cab206cb43e635d9c3a.svg";
export { ForwardRef as ReactComponent };